import { createSelector } from "reselect";

const selectLenderClosingReasonsState = state => state.lenderCallLogLenderClosingReasonsStore || {};

export const selectLenderClosingReasons = createSelector(
  [selectLenderClosingReasonsState],
  state => state.lenderClosingReasons || [],
);
